/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { useAppContext } from '../../context/appContext'
export default function Mouth5(props) {
  const { colorArr } = useAppContext()
  const { nodes, materials } = useGLTF('/models/Mouth5.glb')
  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Mouth5.geometry}
        material={materials.Red}
        position={[-0.28, 84.63, 123.74]}
      >
        <meshPhysicalMaterial
          color={colorArr[2]}
          reflectivity={1}
          roughness={0.8}
        />
      </mesh>
    </group>
  )
}

useGLTF.preload('/models/Mouth5.glb')
